import { Redirect, Route, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes } from '@webapp/hooks'
import { Permissions } from '@webapp/platform/iam'
import { ExpenseApprovalsPage } from './ExpenseApprovalsPage'
import { ExpenseStatusPage } from './ExpenseStatusPage'
import { useModuleConfig } from '../module/useModuleConfig'

export const ExpenseRouter = () => {
  const { brp, url } = useAppRoutes()

  const { showExpenseRoutes } = useModuleConfig()

  if (!showExpenseRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <ProtectedRoute
        path={brp('ExpenseApprovalsPage', { status: ':status' })}
        component={ExpenseApprovalsPage}
        featureFlags={['ARCH_514_MIGRATION_EXPENSE_APPROVALS']}
        permissions={[Permissions.APPROVE_ORDER]}
      />

      <ProtectedRoute
        path={brp('ExpenseStatusPage', { status: ':status' })}
        component={ExpenseStatusPage}
      />

      <Redirect
        exact
        from={brp('ExpenseApprovalsPage', { status: '' })}
        to={url('ExpenseApprovalsPage', { status: 'pending' })}
      />

      <Route
        path='*'
        render={() => (
          <Redirect to={url('ExpenseStatusPage', { status: 'pending' })} />
        )}
      />
    </Switch>
  )
}
